import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon, XIcon } from "lucide-react";
import { buyers, images } from "../data/content";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(i => (i + 1) % buyers.length);
      setMinutes(Math.floor(Math.random() * 14) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), 5000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <AnimatePresence data-id="element-45" data-mp="165pjw8a9imau">
      {open && !dismissed && <motion.div role="status" initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 right-3 top-3 z-50 md:left-5 md:right-auto md:top-auto md:bottom-28 md:w-[360px]" data-id="element-46" data-mp="16467wtvn2xev">
          <div className="relative flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(10,26,51,0.35)]" data-id="element-47" data-mp="n7dduvendsjh">
            <img src={images.main} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-canvas object-contain" data-id="element-48" data-mp="x5kq50xzrmf5" />
            <div className="min-w-0" data-id="element-49" data-mp="s56fdb509ydf">
              <p className="text-sm leading-snug text-ink" data-id="element-50" data-mp="s8auh3k0eeiv">
                <strong className="font-bold" data-id="element-51" data-mp="28jeoo40rmb74">{buyer.name}</strong> from <strong className="font-bold" data-id="element-52" data-mp="23ld93t2jsu0e">{buyer.country}</strong> just purchased the Implant Planning Playbook™
              </p>
              <p className="mt-1 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-53" data-mp="2anji9cw5y368">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-54" data-mp="2fmv3ay3kbutm" /> Verified purchase · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-ink-muted hover:bg-canvas" aria-label="Close notification" data-id="element-55" data-mp="2kniov490vjgg">
              <XIcon className="h-4 w-4" data-id="element-56" data-mp="1wwdcx067dbbf" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}